import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Post } from "@domain/post/post";
import { AppAuthIncentive } from "@ui/components/appAuthIncentive";
import { ArrowIcon } from "@ui/components/icons";
import { Page } from "@ui/components/page";
import { PostView } from "@ui/components/post/postView";
import { PersonCard } from "@ui/components/profile/personCard";
import { SliderPub } from "@ui/components/pub/sliderPub";
import { StickyColumn } from "@ui/components/stickyColumn";
import { theme } from "@ui/styles/theme";
import { gap } from "@ui/styles/utils";
import { SocialLoginCard } from "@ui/pages/loginPage/socialLoginCard";
// import { HeadMetaData } from "../../../core/routing/headMetaData";
// import { Path } from "../../../core/routing/path";
// import { Seo } from "../../../core/routing/seo";

interface PostPageWebProps extends React.HTMLAttributes<HTMLDivElement> {
	post: Post;
}

export const PostPageWeb: React.FC<PostPageWebProps> = ({ post, ...htmlProps }) => {
	const currentProfile = useCurrentProfile();

	const history = useHistory();
	const { author } = post;

	return (
		<Container {...htmlProps}>
			{/* <HeadMetaData
				ogUrl={`https://app-dev.tooshare.com${Path.Post(post.id)}`}
				title={post.author.primaryName}
				image={post.assetUrl}
				description={post.text?.getPlainText()}
			/> */}
			{/* <Seo title={post.author.primaryName} description={post.text?.getPlainText()} /> */}
			<StyledLeft>
				<PersonCard person={author} />
			</StyledLeft>
			<StyledBackButton>
				<StyledArrowIcon onClick={() => history.goBack()}>
					<ArrowIcon color={theme.colors.secondary} />
				</StyledArrowIcon>
				<BackTitle>{I18n.t("post.title")}</BackTitle>
			</StyledBackButton>
			<PostView post={post} />
			<StyledRight>
				{!currentProfile ? <SocialLoginCard /> : null}
				<SliderPub />
			</StyledRight>
			{!currentProfile && <AppAuthIncentive />}
		</Container>
	);
};

const Container = styled(Page)`
	display: grid;
	grid-template-columns: 280px minmax(0, 1fr) 280px;
	grid-template-rows: auto;
	grid-column-gap: 20px;
	grid-row-gap: 24px;
	grid-template-areas:
		"profile header suggestions"
		"profile input suggestions"
		"profile input suggestions"
		"profile feed suggestions"
		"profile feed ."
		". feed ."
		". feed ."
		". feed ."
		". feed ."
		". feed .";

	@media (max-width: 900px) {
		grid-template-columns: 100%;

		grid-template-areas:
			"input"
			"feed";
	}
`;

const StyledRight = styled(StickyColumn)`
	grid-area: suggestions;
	${gap(24)};
	@media (max-width: 900px) {
		display: none;
	}
`;

const StyledLeft = styled(StickyColumn)`
	@media (max-width: 900px) {
		display: none;
	}
	position: sticky;
	grid-area: profile;
	${gap(20)};
`;

const StyledBackButton = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
`;
const StyledArrowIcon = styled.div`
	width: 50px;
	height: 50px;
	border-radius: 50%;
	cursor: pointer;
	background-color: ${({ theme }) => theme.colors.white};
	display: flex;
	align-items: center;
	justify-content: center;
`;

const BackTitle = styled.div`
	${({ theme }) => theme.textStyles.title}
`;
